import { Course } from 'app2/api';
import { waitlistPresentCheck } from './waitlistPresentCheck';
import { enrollmentDatesWillChangeCheck } from './enrollmentDatesWillChangeCheck';

// returns true if the user cancels the dialog
export async function coursePreSaveChecks(courses: Courses): Promise<boolean> {
  return await waitlistPresentCheck(courses) || await enrollmentDatesWillChangeCheck(courses);
}

type Courses = Array<Pick<Course, 'id' | 'name' | 'startDate' | 'endDate' | 'maxCapacity' | 'status'>>;